var map = {
	"./boards_store.js": 74,
	"./boards_store.js.es6": 74,
	"./modal_store.js": 75,
	"./modal_store.js.es6": 75
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;



//////////////////
// WEBPACK FOOTER
// ./boards/stores ^\.\/.*\.(js|es6)$
// module id = 163
// module chunks = 1